import Modal from '@/components/modals/Modal';
import YouTubeVideo, { VideoWrapper } from '@/components/YouTubeVideo';
import gtm from '@/lib/gtm';
import { mediaBreakpointUp } from '@/styles/layout/utils';
import { remCalc } from '@/styles/typography/utils';
import { FC } from 'react';
import styled from 'styled-components';

interface YouTubeVideoModalProps {
  onClose: () => void;
  videoId: string;
  coverSrc?: string;
  showPlayButton: boolean;
  videoName: string;
}

const YouTubeVideoModal: FC<YouTubeVideoModalProps> = ({ onClose, videoId, coverSrc, showPlayButton, videoName }) => (
  <StyledModal name={videoName} onClose={onClose} whiteCloseButton={true}>
    <YouTubeVideo
      videoId={videoId}
      coverSrc={coverSrc}
      showPlayButton={showPlayButton}
      autoplay
      onInitialPlay={() => {
        gtm.track('play_video', {
          video_title: videoName,
          video_youtube_id: videoId,
          video_url: 'https://youtube.com/watch?v=' + videoId,
        });
      }}
    />
  </StyledModal>
);

export default YouTubeVideoModal;

const StyledModal = styled(Modal)`
  --modal-background-color: transparent;
  --modal-padding: ${remCalc(10)};
  --modal-button-top: ${remCalc(-24)};
  --modal-button-right: ${remCalc(0)};

  ${VideoWrapper} {
    border-radius: 10px;
    overflow: hidden;
  }

  ${mediaBreakpointUp('tablet')} {
    --modal-button-top: ${remCalc(24)};
    --modal-button-right: ${remCalc(0)};
    --modal-padding: ${remCalc(40)};
  }

  ${mediaBreakpointUp('desktop')} {
    --modal-button-top: ${remCalc(80)};
    --modal-button-right: ${remCalc(44)};
    --modal-padding: ${remCalc(80)};
  }
`;
